import React, { forwardRef } from 'react';
import cx from 'classnames';
import { CLASS_PAGE } from '../../css-api';

const Page = forwardRef(({ id, alignSelf, classNames, children, styles }, ref) => {
  return (
    <main
      id={id}
      ref={ref}
      className={cx(CLASS_PAGE, classNames)}
      style={{ flexGrow: 1, alignSelf, ...styles }}
    >
      {children}
    </main>
  );
});

export default Page;
